import Slider from 'react-slick';
import Constants from '../../../../utils/Constants';
import ScrollAnimation from '../../../../utils/ScrollAnimation';
import { DestinationsList } from './DestinationsList';

const Destinations = () => {
  const slickSettingsImgs = {
    focusOnSelect: true,
    infinite: true,
    centerMode: true,
    centerPadding: '200px',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '120px',
        },
      },
      {
        breakpoint: 801,
        settings: {
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div id={Constants.DESTINATION} className='destinations'>
      <div className='destinations_container container'>
        <ScrollAnimation animateIn='fadeIn' animateOut='fadeOut' duration={100}>
          <ScrollAnimation animateIn='fadeInUp' duration={500} delay={100}>
            <h2 className='text_center'>SENSE OF DESTINATION</h2>
          </ScrollAnimation>
          <ScrollAnimation animateIn='fadeIn' delay={150}>
            <Slider {...slickSettingsImgs}>
              {DestinationsList.map((destination) => (
                <div className='destinations_container_slider_container'>
                  <div className='destinations_container_slider_container_img'>
                    <img src={destination.img} alt={destination.title} />
                  </div>
                  <div className='destinations_container_slider_container_title'>
                    <h2 className='text_center'>{destination.title}</h2>
                    <a
                      href={destination.link}
                      target='_blank'
                      rel='noreferrer'
                      className='opacity_transition_high'
                    >
                      SHOW MORE
                    </a>
                  </div>
                </div>
              ))}
            </Slider>
          </ScrollAnimation>
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default Destinations;
